import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=38f317e4&scoped=true"
import script from "./Modal.js?vue&type=script&lang=js&external"
export * from "./Modal.js?vue&type=script&lang=js&external"
import style0 from "./Modal.vue?vue&type=style&index=0&id=38f317e4&prod&lang=scss&scoped=true"
import style1 from "@voerro/vue-tagsinput/dist/style.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f317e4",
  null
  
)

export default component.exports